'use client';

import { useEffect, useState } from 'react';
import Icon from './icon';
import tocbot from 'tocbot';

export default function TableOfContents() {
  const [showToc, setShowToc] = useState(false);

  useEffect(() => {
    tocbot.init({
      tocSelector: '.js-toc',
      contentSelector: '.js-toc-content',
      headingSelector: 'h2, h3, h4',
      hasInnerContainers: true,
      headingsOffset: 80,
      scrollSmoothOffset: -80,
      isCollapsedClass: 'is-collapsed',
      scrollSmooth: true,
      disableTocScrollSync: true,
      tocScrollingWrapper: null,
    });
    return () => tocbot.destroy();
  }, []);
  return (
    <>
      <button
        className="flex items-center rounded-full border border-accent-brd px-4 py-1 text-sm font-medium uppercase hover:bg-accent-bg-2
        md:cursor-default md:border-none md:p-0 md:hover:bg-transparent"
        aria-label="Table of Contents"
        onClick={() => setShowToc(!showToc)}
      >
        <span className="mr-2">Table of Contents</span>
        <Icon name="chevron-down" className="h-4 w-4 md:hidden" />
      </button>
      <div
        className={`js-toc relative mb-4 leading-5 md:max-h-[80vh] md:overflow-y-scroll ${
          showToc ? 'block' : 'hidden md:block'
        }`}
      ></div>
    </>
  );
}
